import * as React from 'react';
import { withRouter, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import { SalesLayout } from './SalesLayout';
import { CustomerOrdersPage } from './CustomerOrders/CustomerOrdersPage';
import { NewCustomerOrderPage } from './CustomerOrders/Create/NewCustomerOrderPage';
import { CustomerOrderDetailsPage } from './CustomerOrders/Details/CustomerOrderDetailsPage';
import { DraftOrdersPage } from './CustomerOrders/DraftOrdersPage';
import { RejectionsPage } from './Rejections/RejectionsPage';
import { VinQueriesPage } from './VinQueries/VinQueriesPage';
import { VinQueryDetailsPage } from './VinQueries/VinQueryDetailsPage';

@observer
class SalesRouterComponent extends React.Component<any, any> {
    render() {
        return (
            <SalesLayout>
                {/* <Route path='/' component={CustomerOrdersPage} /> */}
                <Route path='/sales/vinqueries/:page?' component={VinQueriesPage} />
                <Route path='/sales/vinquerydetails/:id/:backUrl?' component={VinQueryDetailsPage} />
                <Route path='/sales/customerorders/:page?' component={CustomerOrdersPage} />
                <Route path='/sales/draftorders/:page?' component={DraftOrdersPage} />
                <Route path='/sales/rejections/:page?' component={RejectionsPage} />
                <Route path='/sales/orderdetails/:orderGuid/:backUrl?' component={CustomerOrderDetailsPage} />
                <Route path='/sales/newcustomerorder/:draftOrderId?/:vinId?' component={NewCustomerOrderPage} />
            </SalesLayout>
        );
    }
}

const SalesRouter = withRouter(SalesRouterComponent)
export default SalesRouter;